import { Box, Flex } from '@sequencehq/core-components'
import { useAtomValue } from 'jotai'
import { phasesAtom } from '../atoms/reviewPricing.atoms'
import { Phase } from './Phase/Phase'
import { ReviewPricingDrawers } from './ReviewPricingDrawers'
import { AdditionalInformation } from './AdditionalInformation'
import { AddPhaseButton } from './Phase/AddPhaseButton'

export const SchedulePricing = () => {
  const phases = useAtomValue(phasesAtom)

  return (
    <Box>
      <Flex marginBottom="16px" flexDirection="column" gap="16px">
        {phases.map(phase => (
          <Phase phaseId={phase.id} key={phase.id} />
        ))}
      </Flex>

      <Box marginBottom="24px">
        <AddPhaseButton />
      </Box>

      <AdditionalInformation />
      <ReviewPricingDrawers />
    </Box>
  )
}
